import React, {useState, useEffect, useRef} from "react";
import {
    Form, Container, Row, Col, Card, Table, Tab, Tabs, Tooltip, OverlayTrigger,
} from "react-bootstrap";
import "./VendorAssignment.css";
import {useForm} from "react-hook-form";
import plus from "../../../images/plus.png";
import arrow from "../../../images/arrow.png";
import tick from "../../../images/tick.png";
import del from "../../../images/delete.ico";
import axios from "../../util/Axios/AxiosInstance";
import AOS from "aos";
import "aos/dist/aos.css";

function VendorAssignment({data}) {
    const rowData = data;
    const [clRequestsData, setClRequestsData] = useState(rowData);

    const branchId = localStorage.getItem("branchId");
    const branchName = localStorage.getItem("branch");
    const [selected, setSelected] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (name, id) => {
        setShiftId(id);
        setShiftName(name);
        setShow(true);
    };

    const [SBshow, SBsetShow] = useState(false);
    const SBhandleClose = () => SBsetShow(false);
    const SBhandleShow = () => SBsetShow(true);

    const [SCshow, SCsetShow] = useState(false);
    const SChandleClose = () => SCsetShow(false);
    const SChandleShow = () => SCsetShow(true);

    const [SGshow, SGsetShow] = useState(false);
    const SGhandleClose = () => SGsetShow(false);
    const SGhandleShow = () => SGsetShow(true);

    const [showResults, setShowResults] = React.useState(false);
    const onClick = () => setShowResults(true);
    const {
        register, handleSubmit, formState: {errors},
    } = useForm();
    const onSubmit = (data) => {
    };
    const [deptList, setDeptList] = useState([{department_id: "", department_name: ""},]);
    const [subDepartmentList, setSubDeptList] = useState([]);
    const [vendorList, setVendorList] = useState([]);

    const [transactionId, setTransactionId] = useState([]);
    const [vendorId, setVendorId] = useState("");
    const [vendorName, setVendorName] = useState("");
    const [transactionDate, setTransactionDate] = useState(clRequestsData.date);
    const [deptId, setDeptId] = useState(clRequestsData.departmentId);
    const [subDeptId, setSubDeptId] = useState(clRequestsData.subDepartmentId);
    const [deptName, setDeptName] = useState(clRequestsData.department);
    const [subDeptName, setSubDeptName] = useState(clRequestsData.subDepartment);
    const [createdBy, setCreatedBy] = useState([]);
    const [createdDate, setCreatedDate] = useState([]);
    const [message, setMessage] = useState("");
    const [key, setKey] = useState("");
    const [shiftDet, setShiftDet] = useState([]);
    const [shiftId, setShiftId] = useState("");
    const [shiftName, setShiftName] = useState("");
    const [vendorTransactionDetails, setvendorTransactionDetails] = useState([]);
    const [vendorDetailsByIdsByShiftId, setVendorDetailsByIdsByShiftId] = useState([]);
    const [totalEmpReq, setTotalEmpReq] = useState([]);
    const [reqMaleEmp, setReqMaleEmp] = useState([]);
    const [reqMaleEmp0, setReqMaleEmp0] = useState("");
    const [reqMaleEmp1, setReqMaleEmp1] = useState("");
    const [reqMaleEmp2, setReqMaleEmp2] = useState("");
    const [reqMaleEmp3, setReqMaleEmp3] = useState("");

    const [reqFemaleEmp, setReqFemaleEmp] = useState([]);
    const [reqFemaleEmp0, setReqFemaleEmp0] = useState("");
    const [reqFemaleEmp1, setReqFemaleEmp1] = useState("");
    const [reqFemaleEmp2, setReqFemaleEmp2] = useState("");
    const [reqFemaleEmp3, setReqFemaleEmp3] = useState("");
    const [resAddVendorTransactionMasterDetailsJson, setResAddVendorTransactionMasterDetailsJson,] = useState([]);
    const [resJson, setResJson] = useState([]);
    const [resultArray, setResultArray] = useState([{
        submitted: "", maleCount: "", femaleCount: "", vendorAssignedTotalCount: "", vendorId: "",
    },]);
    const [plusError, setPlusError] = useState(false);
    const [draftData, setDraftData] = useState("");
    const [draftError, setDraftError] = useState("");
    const [deptVendorDataAdd, setDeptVendorDataAdd] = useState({});
    const [showCount, setShowCount] = useState(false);
    const [showShiftTabs, setShowShiftTabs] = useState(false);
    const [clrShiftReq, setClrShiftReq] = useState(clRequestsData);
    const [clrTotalReq, setClrTotalReq] = useState("");
    const [clrTotalMaleReq, setClrTotalMaleReq] = useState("");
    const [clrTotalFemaleReq, setClrTotalFemaleReq] = useState("");
    const maleRefNum = useRef("");
    const maleRefNum0 = useRef(0);
    const maleRefNum1 = useRef(0);
    const maleRefNum2 = useRef(0);
    const maleRefNum3 = useRef(0);
    const femaleRefNum = useRef("");
    const femaleRefNum0 = useRef(0);
    const femaleRefNum1 = useRef(0);
    const femaleRefNum2 = useRef(0);
    const femaleRefNum3 = useRef(0);
    const [malecountError, setMalecountError] = useState(false);
    const [femalecountError, setFemalecountError] = useState(false);
    const [proceedError, setProceedtError] = useState(false);
    const [submitError, setSubmitError] = useState(false);
    const [checkData, setCheckData] = useState(false);
    const [emptyError, setEmptyError] = useState(false);
    const [submittingIndex, setSubmittingIndex] = useState(null);
    const genderSpecific = localStorage.getItem("genderSpecific");
    // const resultArray = useRef([{
    //     submitted : true
    // }]);

    // const onProceed = (e) => {
    //     e.preventDefault();
    //     for(let i = 0; i<resultArray.length;i++){
    //         submitVendorTransactionDetails(e,i);
    //     }
    // }

    let submitVendorTransactionDetails = async (e, index) => {
        e.preventDefault();

        // Prevent multiple submissions
        if (submittingIndex === index) {
            return;
        }

        if (malecountError == true || femalecountError == true) {
            return;
        }
        if (!resultArray[index].vendorId || resultArray[index].vendorId == "" || !resultArray[index].maleCount || resultArray[index].maleCount == "" || !resultArray[index].femaleCount || resultArray[index].femaleCount == "") {
            let newArr = [...resultArray];
            newArr[index].submitError = true;
            setResultArray(newArr);

            return;
        }

        // Set loading state
        setSubmittingIndex(index);

        let newArr = [...resultArray];
        newArr[index].submitError = false;
        newArr[index].submitted = false;
        setResultArray(newArr);

        const userName = localStorage.getItem("username");
        var currentdate = new Date();
        var datetime = currentdate.getFullYear() + "-" + (currentdate.getMonth() + 1) + "-" + currentdate.getDate() + " " + currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();
        const addVendorTransactionDetailsData = {
            transactionDate: transactionDate,
            shiftId: shiftId,
            shiftName: shiftName,
            deptId: deptId, // deptName: deptName,
            subDeptId: subDeptId, // subDeptName: subDeptName,
            totalEmpCount: clrTotalReq,
            vendorId: resultArray[index].vendorId, // vendorName: resultArray[index].vendorName,
            maleCount: resultArray[index].maleCount,
            femaleCount: resultArray[index].femaleCount,
            vendorAssignedTotalCount: resultArray[index].vendorAssignedTotalCount,
            requiredMaleCount: clrTotalMaleReq,
            requiredFemaleCount: clrTotalFemaleReq,
            branchId: branchId, // branchName: branchName,
            // maleCount: maleRefNum.current,
            // femaleCount: femaleRefNum.current,
            createdBy: userName,
            createdDate: datetime,
        };

        axios
            .post("addVendorTransactionDetails", addVendorTransactionDetailsData)
            .then((data) => {
                if (data.status === 200) {
                    let newArr = [...resultArray];
                    newArr[index].submitted = true;
                    setResultArray(newArr);
                    setPlusError(false);
                    maleRefNum.current = "";
                    femaleRefNum.current = "";
                    setVendorId("");
                    setShow(false);
                } else {
                    // Handle non-200 status
                    setSubmittingIndex(null);
                }
            })
            .catch((error) => {
                let newArr = [...resultArray];
                newArr[index].submitted = "";
                setResultArray(newArr);
                setSubmittingIndex(null);
                console.error(error);
            })
            .finally(() => {
                // Clear loading state
                setSubmittingIndex(null);
            });
    };

    let getCLRErodeDataByDateDeptSubDept = async (e) => {
        e.preventDefault();

        if (transactionDate == "" || deptName == "" || subDeptName == "") {
            setProceedtError(true);

            return;
        }
        setProceedtError(false);
        const CLRFilterData = {
            date: transactionDate, department: deptName, subDepartment: subDeptName, plantName: "Erode",
        };
        axios
            .post("getCLRErodeDataByDateDeptSubDept", CLRFilterData)
            .then((data) => {
                if (data.status === 200) {
                    if (data.data.length > 0) {
                        setClrShiftReq(data.data[0]);
                        setEmptyError(false);
                    } else {
                        setEmptyError(true);
                        setClrShiftReq({});
                    }
                    // data.data.length > 0 ? setClrShiftReq(data.data[0]) : setClrShiftReq({});
                    setShowShiftTabs(true);
                } else {
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    let submitDeptVendorData = async (e) => {
        e.preventDefault();

        //

        var currentdate = new Date();
        var datetime = currentdate.getFullYear() + "-" + (currentdate.getMonth() + 1) + "-" + currentdate.getDate() + " ";
        // + currentdate.getHours() + ":"
        // + currentdate.getMinutes() + ":"
        // + currentdate.getSeconds();
        const deptVendorDataAdd = {
            // transactionId,
            vendorId: vendorId,
            transactionDate: transactionDate,
            subDeptId: key,
            deptId: deptId,
            createdBy: "admin",
            createdDate: datetime,
        };

        axios
            .post("addVendorTransactionMasterDetails", deptVendorDataAdd)
            .then((data) => {
                if (data?.status === 200) {
                    deptVendorDataAdd.TransactionId = data.data.TransactionId;
                    setDeptVendorDataAdd(deptVendorDataAdd);
                    if (show === true) {
                        setShowCount(true);
                    }
                } else {
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        AOS.init();
        getCLRequestsDetails();

        // getDepartmentDetails();
        getVendorMasterDetailsByBranch(branchId);
        getShiftDetails();
    }, []);

    useEffect(() => {
    }, [resultArray, shiftId, shiftName, deptName, subDeptId, subDeptName, transactionDate,]);

    useEffect(() => {
    }, [clrShiftReq, clrTotalReq, clrTotalMaleReq, clrTotalFemaleReq,]);

    const getCLRequestsDetails = () => {
        setShiftId("");
        setResultArray([{submitted: ""}]);
        setProceedtError(false);
        setShowShiftTabs(true);
        setEmptyError(false);
    };
    const getDepartmentDetails = () => {
        axios
            .get("getDepartmentDetails")
            .then((data) => {
                if (data.status === 200) {
                    const newData = data.data;
                    setDeptList(newData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    // getVendorTransactionDetails

    const addVendorMale = (e, i) => {
        maleRefNum.current = e.target.value;
        let newArr = [...resultArray];
        newArr[i].maleCount = e.target.value;
        // let existornot = newArr.reduce(function (accumulator,currentVal){
        //     return Number(accumulator) + Number(currentVal.maleCount);
        // }, 0);
        //
        // if(existornot > clrTotalMaleReq){
        //     setMalecountError(true);
        //     return;
        // }
        // setMalecountError(false);
        newArr[i].vendorAssignedTotalCount = Number(newArr[i].maleCount) + Number(newArr[i].femaleCount);
        setResultArray(newArr);
    };

    const addVendorFemale = (e, i) => {
        femaleRefNum.current = e.target.value;
        let newArr = [...resultArray];
        newArr[i].femaleCount = e.target.value;
        // let femaleexistornot = newArr.reduce(function (accumulator,currentVal){
        //     return Number(accumulator) + Number(currentVal.femaleCount);
        // }, 0);
        //
        // if(femaleexistornot > clrTotalFemaleReq){
        //     setFemalecountError(true);
        //     return;
        // }
        // setFemalecountError(false);
        newArr[i].vendorAssignedTotalCount = Number(newArr[i].maleCount) + Number(newArr[i].femaleCount);
        setResultArray(newArr);
    };

    const updateTotalCount = (e, i) => {
        let newArr = [...resultArray];
        newArr[i].maleCount = "0";
        newArr[i].femaleCount = "0";
        newArr[i].vendorAssignedTotalCount = e.target.value;
        setResultArray(newArr);
    };
    const getVendorDetailsByIdsByShiftId = (shiftId) => {
        axios
            .get("getVendorTransactionDetailsByDateAndIds/" + transactionDate + "/" + deptId + "/" + subDeptId + "/" + shiftId)
            .then((data) => {
                if (data.status === 200) {
                    if (data.data.length > 0) {
                        setResultArray(data.data);
                        setCheckData(true);
                    } else {
                        setResultArray([{
                            submitted: "", maleCount: "", femaleCount: "", vendorAssignedTotalCount: "", vendorId: "",
                        },]);
                        setCheckData(false);
                    }
                } else {
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };
    const onChangeShift = (key, e) => {
        if (maleRefNum.current != "" || femaleRefNum.current != "" || vendorId != "") {
            setDraftError(true);

            return;
        }
        setClrTotalReq("");
        setClrTotalMaleReq("");
        setClrTotalFemaleReq("");

        switch (key) {
            case "1":
                setClrTotalReq(clrShiftReq.shiftA);
                setClrTotalMaleReq(clrShiftReq.shiftAMale);
                setClrTotalFemaleReq(clrShiftReq.shiftAFemale);
                break;
            case "2":
                setClrTotalReq(clrShiftReq.shiftB);
                setClrTotalMaleReq(clrShiftReq.shiftBMale);
                setClrTotalFemaleReq(clrShiftReq.shiftBFemale);
                break;
            case "3":
                setClrTotalReq(clrShiftReq.shiftC);
                setClrTotalMaleReq(clrShiftReq.shiftCMale);
                setClrTotalFemaleReq(clrShiftReq.shiftCFemale);
                break;
            case "4":
                setClrTotalReq(clrShiftReq.general);
                setClrTotalMaleReq(clrShiftReq.generalMale);
                setClrTotalFemaleReq(clrShiftReq.generalFemale);
                break;
            default:
        }
        setShiftId(key);
        setShiftName(e.target.innerHTML);
        setDraftError("");

        getVendorDetailsByIdsByShiftId(key);
    };

    const handleShiftMaleEmp = (e) => {
        // switch (index) {
        //     case 0:
        //
        //         maleRefNum0.current = e.target.value;
        //
        //         break;
        //     case 1:
        //
        //         maleRefNum1.current = e.target.value;
        //
        //         break;
        //     case 2:
        //
        //         maleRefNum2.current = e.target.value;
        //
        //         break;
        //     case 3:
        //
        //         maleRefNum3.current = e.target.value;
        //
        //         break;
        // }
        // setReqMaleEmp(e.target.value);
        // setShiftId(id);
        //
    };

    const handleShiftFemaleEmp = (e, id, shiftname, index) => {
        switch (index) {
            case 0:
                femaleRefNum0.current = e.target.value;

                break;
            case 1:
                femaleRefNum1.current = e.target.value;

                break;
            case 2:
                femaleRefNum2.current = e.target.value;

                break;
            case 3:
                femaleRefNum3.current = e.target.value;

                break;
        }
        // setReqMaleEmp(e.target.value);
        setShiftId(id);
    };

    const onSelectVendorShift = (e, i) => {
        setVendorId(e.target.value);
        setVendorName(e.target.selectedOptions[0].id);
        let newArr = [...resultArray];
        newArr[i].vendorId = e.target.value;
        newArr[i].vendorName = e.target.selectedOptions[0].id;
        setResultArray(newArr);
        setDraftData(true);
    };

    const getVendorTransactionDetails = () => {
        axios
            .get("getVendorTransactionDetails")
            .then((data) => {
                if (data.status === 200) {
                    const newData = data.data;
                    setvendorTransactionDetails(newData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getSubDepartmentDetailsbyDeptID = (departmentId) => {
        axios
            .get("getSubDepartmentDetailsbyDeptID/" + departmentId)
            .then((data) => {
                if (data.status === 200) {
                    const subDeptData = data.data;

                    setSubDeptList(subDeptData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getVendorMasterDetailsByBranch = (branchId) => {
        axios
            .get("getVendorMasterDetailsByBranchId/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const vendorList = data.data;

                    setVendorList(vendorList);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getShiftDetails = () => {
        axios
            .get("getShiftDetails")
            .then((data) => {
                if (data.status === 200) {
                    const shiftDet = data.data;
                    setShiftDet(shiftDet);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const onSelectDate = (e) => {
        setTransactionDate(e.target.value);
        setResultArray([{submitted: ""}]);
        setShiftId("");
        setShowShiftTabs(false);
    };

    // const onSelectDept = (e) => {
    //     setDeptId(e.target.value);
    //     setDeptName(e.target.selectedOptions[0].id);
    //     setShiftId('');
    //     setResultArray([{submitted:''}])
    //     setShowShiftTabs(false);
    //     getSubDepartmentDetailsbyDeptID(e.target.value);
    // }

    const onSelectSubDept = (e) => {
        setSubDeptId(e.target.value);
        setSubDeptName(e.target.selectedOptions[0].id);
        setShiftId("");
        setResultArray([{submitted: ""}]);
        setShowShiftTabs(false);
    };

    const onSelectVendor = (e) => {
        setVendorId(e.target.value);
    };

    const addOne = (e, result, i) => {
        // if(result.submitted == true)
        // {
        //
        setResultArray([...resultArray, {
            submitted: "", maleCount: "", femaleCount: "", vendorAssignedTotalCount: "", vendorId: "",
        },]);
        // resultArray.current.push({});
        // resultArray.current = [...resultArray.current,{ submitted: ''}];

        // }
        // else{
        //
        //     let newArr = [...resultArray];
        //     newArr[i].submitted = false;
        //     setResultArray(newArr);
        //     setPlusError(true);
        // }
    };

    const delOne = (e, result, i) => {
        const newArray = [...resultArray];
        newArray.splice(i, 1);
        setResultArray(newArray);
    };

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Submit
        </Tooltip>
    );

    return (<Container fluid className="px-0">
        <div className="">
            <div className="mt-2">
                {/*<h2 className='Title'>Vendor Assignment</h2>*/}
                <h5 className={"priColor"}>Vendor Assignment</h5>
            </div>
            <div data-aos="zoom-in-right" data-aos-duration="450">
                {/* <Form onSubmit={handleSubmit(onSubmit)}> */}
                <Card className="cardStyl">
                    <div className="container">
                        <Form onSubmit={submitDeptVendorData}>
                            {/* <Form> */}
                            <div className="row pb-4">
                                <div className="col-lg-3 col-md-3 col-sm-12">
                                    <Form.Label column className="control-label, textBold">
                                        Date{" "}
                                    </Form.Label>
                                    <Col>
                                        <Form.Control
                                            disabled
                                            type="date"
                                            placeholder="Enter here.."
                                            // {...register("Date", { required: true })}
                                            onChange={(e) => onSelectDate(e)}
                                            value={transactionDate}
                                        />

                                        {proceedError === true && transactionDate === "" && (
                                            <p className="RequiredFields">Please Select Date</p>)}
                                    </Col>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <Form.Label column className="control-label, textBold">
                                        Department{" "}
                                    </Form.Label>
                                    <Col>
                                        <Form.Control
                                            disabled
                                            type="text"
                                            placeholder="Dept Name"
                                            value={deptName}
                                        />
                                    </Col>
                                    {/* <Form.Label column className="control-label, textBold">Department  </Form.Label>
                                        <Col>
                                            <Form.Select
                                                // name={deptList}
                                                // onChange={(e) => onSelectDept(e)}
                                            // value={deptName}
                                            >
                                                <option key="" value="" id="">Select the Dept</option>
                                                {
                                                    deptList.map(dept => (
                                                        <option key={dept.department_id} value={dept.department_name} id={dept.department_name}>
                                                            {dept.department_name}
                                                        </option>
                                                    ))}
                                            </Form.Select>

                                            {proceedError === true && deptId === ''&& <p className="RequiredFields">Please Select Dept</p>}
                                        </Col> */}
                                </div>

                                <div className="col-lg-5 col-md-5 col-sm-12">
                                    <Form.Label column className="control-label, textBold">
                                        Sub-Department{" "}
                                    </Form.Label>
                                    <Col>
                                        <Form.Control
                                            disabled
                                            type="text"
                                            placeholder="Sub-Dept Name"
                                            value={subDeptName}
                                        />
                                    </Col>
                                    {/* <Form.Label column className="control-label, textBold">Sub-Department</Form.Label>
                                        <Col>
                                            <Form.Select
                                                aria-label="Default select example"
                                                placeholder='Select Sub-Department'
                                                onChange={(e) => onSelectSubDept(e)}
                                                value={subDeptName}
                                                // onChange={e => setKey(e.target.value)}
                                            >

                                                <option>Select Sub-Department</option>
                                                {
                                                    subDepartmentList.map(subDept => (
                                                        <option key={subDept.subDepartmentId} id={subDept.subDepartmentName} value={subDept.subDepartmentName}>
                                                            {subDept.subDepartmentName}
                                                        </option>
                                                        // <option value="2">Vendor-2</option>
                                                        // <option value="3">Vendor-3</option>
                                                    ))}
                                            </Form.Select>
                                            {proceedError === true && subDeptId === ''&& <p className="RequiredFields">Please Select SubDept</p>}
                                        </Col> */}
                                </div>

                                {/* <div className="col-lg-3 col-md-3 col-sm-12">
                                        <Col className="SearchButton">
                                            <Button variant="primary" type="submit"
                                                    onClick={(e) => getCLRErodeDataByDateDeptSubDept(e)}>
                                                Proceed </Button>
                                        </Col>
                                    </div> */}
                            </div>
                        </Form>
                    </div>
                    {emptyError === true && (<h5 className="warningMessage">No Data Available.</h5>)}

                    {shiftDet.length > 0 && (<div className="container, PillsBackground p-2 mb-4">
                        <Form onSubmit={submitDeptVendorData}>
                            <Tabs
                                defaultActiveKey={shiftId}
                                activeKey={shiftId}
                                justify
                                variant="pills"
                                onSelect={(k, e) => onChangeShift(k, e)}
                                // onSelect={draftData === '' ? (k) => setShiftId(k) : setDraftError(true)}
                            >
                                {shiftDet.map((shift) => (<Tab
                                    eventKey={shift.shiftId}
                                    key={shift.shiftId}
                                    value={shift.shiftId}
                                    title={shift.shiftName}
                                    className="active-content"
                                ></Tab>))}
                            </Tabs>

                            {draftError == true && (<p className={"errorText"}>Submit all the changes !!!</p>)}

                            {shiftId != "" && clrTotalReq == 0 && (<div>
                                <Card className="cardStyl">
                                    <div>
                                        <h6 className="ShiftTitle">
                                            No Labour Required for this Shift
                                        </h6>
                                    </div>
                                </Card>
                            </div>)}

                            {shiftId != "" && clrTotalReq > 0 && (<div>
                                <Card className="cardStyl">
                                    {/* {vendorTransactionDetails.map(vendorTrnsDet => */}
                                    <div>
                                        <div className="mb-3 div">
                                            <Row>
                                                <Col
                                                    md={4}
                                                    sm={4}
                                                    xl={4}
                                                    lg={4}
                                                    className={"marginAuto"}
                                                >
                                                    <Form.Label className="textBold labelCenter">
                                                        <i>Labours Required : {clrTotalReq}</i>
                                                    </Form.Label>
                                                </Col>
                                                {genderSpecific == "true" ? (<Col
                                                    md={4}
                                                    sm={4}
                                                    xl={4}
                                                    lg={4}
                                                    className={"marginAuto"}
                                                >
                                                    <Form.Label className="textBold labelCenter">
                                                        <i>
                                                            Male Labours Required : {clrTotalMaleReq}
                                                        </i>
                                                    </Form.Label>
                                                </Col>) : ("")}
                                                {genderSpecific == "true" ? (<Col
                                                    md={4}
                                                    sm={4}
                                                    xl={4}
                                                    lg={4}
                                                    className={"marginAuto"}
                                                >
                                                    <Form.Label className="textBold labelCenter">
                                                        <i>
                                                            {" "}
                                                            Female Labours Required :{" "}
                                                            {clrTotalFemaleReq}
                                                        </i>
                                                    </Form.Label>
                                                </Col>) : ("")}
                                            </Row>
                                        </div>
                                        <hr className="mb-0"></hr>
                                        <div>
                                            <Row className="m-0">
                                                <Table
                                                    bordered="false"
                                                    table-hover
                                                    responsive={true}
                                                >
                                                    <thead>
                                                    <tr>
                                                        {/*<th className='shiftHeader'></th>*/}
                                                        <th>Vendor</th>
                                                        {genderSpecific == "true" ? (<th>Male</th>) : ("")}
                                                        {genderSpecific == "true" ? (<th>Female</th>) : ("")}
                                                        {genderSpecific == "false" && (<th>Labour Required</th>)}
                                                        <th>Activities</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {resultArray.map((result, i) => (<tr>
                                                        {/*<th className='shiftHeader' value={shift.shiftId}>{shift.shiftName}</th>*/}

                                                        <td>
                                                            {result.submitted == true || result.id ? (<div>
                                                                <label>{result.vendorName}</label>
                                                            </div>) : (<div>
                                                                <Form.Select
                                                                    aria-label="Default select example subDepartmentList"
                                                                    onChange={(e) => onSelectVendorShift(e, i)}
                                                                    key={result.vendorId}
                                                                    // onChange={e => onSelectVendorShift(e, shift.shiftId, shift.shiftName, index)}
                                                                    value={result.vendorId}
                                                                >
                                                                    <option value="" key={""}
                                                                            id={""}>
                                                                        Select Vendor
                                                                    </option>
                                                                    {vendorList.map((vendor) => (<option
                                                                        key={vendor.id}
                                                                        value={vendor.id}
                                                                        id={vendor.contractName}
                                                                    >
                                                                        {vendor.contractName}
                                                                    </option>))}
                                                                </Form.Select>
                                                            </div>)}
                                                            {result.submitError === true && (result.vendorId === "" || !result.vendorId) && (
                                                                <p className="RequiredFields">
                                                                    Please Select Vendor
                                                                </p>)}
                                                        </td>

                                                        {genderSpecific == "true" ? (<td className="border-bottom-0">
                                                            <Col md={5} sm={5} xl={5} lg={5}>
                                                                {result.submitted == true || result.id ? (<div>
                                                                    <label>
                                                                        {result.maleCount}
                                                                    </label>
                                                                </div>) : (<div>
                                                                    <Form.Control
                                                                        type="number"
                                                                        placeholder="Enter No"
                                                                        onChange={(e) => addVendorMale(e, i)}
                                                                        value={result.maleCount}
                                                                    />
                                                                </div>)}
                                                                {/*{malecountError == true &&*/}
                                                                {/*    <p style={{fontSize:"12px",fontWeight:"500", color:"red"}}>Count exceeds the required limit</p>*/}
                                                                {/*}*/}
                                                                {result.submitError === true && (result.maleCount === "" || !result.maleCount) && (
                                                                    <p className="RequiredFields">
                                                                        Please Enter Malecount
                                                                    </p>)}
                                                            </Col>
                                                        </td>) : ("")}

                                                        {genderSpecific == "true" ? (<td className="border-bottom-0">
                                                            <Col md={5} sm={5} xl={5} lg={5}>
                                                                {result.submitted == true || result.id ? (<div>
                                                                    <label>
                                                                        {result.femaleCount}
                                                                    </label>
                                                                </div>) : (<div>
                                                                    <Form.Control
                                                                        type="number"
                                                                        placeholder="Enter No"
                                                                        onChange={(e) => addVendorFemale(e, i)}
                                                                        // onChange={(e) => handleShiftFemaleEmp(e, shift.shiftId, index)}
                                                                        value={result.femaleCount}
                                                                        // {...register("ShiftAFeMale", { required: true })}
                                                                    />
                                                                </div>)}
                                                                {/*{femalecountError == true &&*/}
                                                                {/*    <p style={{fontSize:"12px",fontWeight:"500", color:"red"}}>Count exceeds the required limit</p>*/}
                                                                {/*}*/}
                                                                {result.submitError === true && (result.femaleCount === "" || !result.femaleCount) && (
                                                                    <p className="RequiredFields">
                                                                        Please Enter Femalecount
                                                                    </p>)}
                                                                {/* {errors.ShiftAFeMale && <p className="RequiredFields">Please Enter No</p>} */}
                                                            </Col>
                                                        </td>) : ("")}
                                                        {genderSpecific == "false" ? (<td className="border-bottom-0">
                                                            <Col md={5} sm={5} xl={5} lg={5}>
                                                                {result.submitted == true || result.id ? (<div>
                                                                    <label>
                                                                        {result.vendorAssignedTotalCount}
                                                                    </label>
                                                                </div>) : (<div>
                                                                    <Form.Control
                                                                        type="number"
                                                                        placeholder="Enter No"
                                                                        onChange={(e) => updateTotalCount(e, i)}
                                                                        value={result.vendorAssignedTotalCount}
                                                                    />
                                                                </div>)}
                                                                {result.submitError === true && (result.vendorAssignedTotalCount === "" || !result.vendorAssignedTotalCount) && (
                                                                    <p className="RequiredFields">
                                                                        Please Enter{" "}
                                                                    </p>)}
                                                                {/* {errors.ShiftAFeMale && <p className="RequiredFields">Please Enter No</p>} */}
                                                            </Col>
                                                        </td>) : ("")}

                                                        <td className="border-bottom-0">
                                                            <div style={{textAlign: "center"}}>
                                                                {resultArray.length - 1 == i && (
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={<Tooltip id="button-tooltip" >
                                                                            Add
                                                                        </Tooltip>}>
                                                                        <img
                                                                            src={plus}
                                                                            alt={""}
                                                                            onClick={(e) => addOne(e, result, i)}
                                                                            className={"plusImage"}
                                                                        />
                                                                    </OverlayTrigger>)}
                                                                {result.submitted == "" && !result.id && (
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={<Tooltip id="button-tooltip" >
                                                                            {submittingIndex === i ? 'Submitting...' : 'Submit'}
                                                                        </Tooltip>}
                                                                    >
                                                                        <img
                                                                            src={arrow}
                                                                            alt={""}
                                                                            className={`plusImage ${submittingIndex === i ? 'submitting' : ''}`}
                                                                            onClick={(e) => {
                                                                                if (!result.submitted && submittingIndex !== i) {
                                                                                    submitVendorTransactionDetails(e, i);
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                opacity: submittingIndex === i ? 0.6 : 1,
                                                                                cursor: submittingIndex === i ? 'not-allowed' : 'pointer'
                                                                            }}
                                                                        />
                                                                    </OverlayTrigger>)}
                                                                {(result.submitted == true || result.id) && (<img
                                                                    src={tick}
                                                                    alt={""}
                                                                    className={"tickImage"}
                                                                />)}
                                                                {submittingIndex === i && result.submitted == "" && !result.id && (
                                                                    <div className="submitting-spinner" style={{
                                                                        display: 'inline-block',
                                                                        marginLeft: '5px',
                                                                        fontSize: '12px',
                                                                        color: '#007bff'
                                                                    }}>
                                                                        Submitting...
                                                                    </div>
                                                                )}
                                                                {i != 0 && !result.id && result.submitted != true && (
                                                                    <img
                                                                        src={del}
                                                                        alt={""}
                                                                        className={"arrowImage"}
                                                                        onClick={(e) => delOne(e, result, i)}
                                                                    />)}
                                                            </div>
                                                        </td>
                                                    </tr>))}
                                                    </tbody>
                                                </Table>
                                                {/* <div className="container">
                                                                            <div className="row">
                                                                            <div className="text-right">
                                                                            <button onClick={(e) => onProceed(e)} type="submit" className="btn btn-success float-end" >Proceed</button>
                                                                            </div>
                                                                            </div>
                                                                            </div> */}
                                            </Row>
                                        </div>
                                    </div>
                                    {plusError == true && (<p className={"errorText"}>
                                        Can't Add New !!! Submit First
                                    </p>)}
                                </Card>
                            </div>)}
                        </Form>
                    </div>)}
                </Card>
            </div>
        </div>
    </Container>);
}

export default VendorAssignment;
